import { convertSvgToCanvas } from "utils/graphics/convertSvgToCanvas";
import { convertCanvasToFile } from "utils/graphics/convertCanvasToFile";
import { ConvertSvgToPng } from "./types";

export const convertSvgToPng: ConvertSvgToPng = async ({
  svgElement,
  fileName = "image.png",
  mimeType = "image/png",
}) => {
  const canvas = await convertSvgToCanvas({ svgElement });
  const file = await convertCanvasToFile({
    canvas,
    fileName,
    mimeType,
  });

  return file;
};
